import {Component, Inject, forwardRef} from '@angular/core';
import {AppComponent} from './app.component';

@Component({
    selector: 'app-footer',
    template: `
        <div class="layout-footer">
            <span class="footer-text-left">
                <img src="assets/layout/images/logo-dark.png" />
            </span>
            <span class="footer-text-right">
                <a href="http://www.ondasat.net/mobitrack/" target="_blank"><img src="assets/layout/images/mobitrack.png"/></a>
                <a href="#" target="_blank"><i class="fa fa-facebook"></i></a>
                <a href="https://www.youtube.com/watch?v=et79XDcAwek" target="_blank"><i class="fa fa-youtube"></i></a>
                <a href="mailto:info@ondasat.net"><i class="fa fa-envelope"></i></a>
            </span>
        </div>
    `
})
export class AppFooterComponent {

}



// WEBPACK FOOTER //
// ./src/app/app.footer.component.ts